import { useEffect, useState } from 'react';
import type { SorterResult } from 'antd/es/table/interface';
import cn from 'classnames';
import { sortNumericValues } from 'utils/helpers/sortHelpers';

import Table from 'components/ui/Table';

import type { TTableColumn, TTableSort } from 'models/Table';

import styles from './TableContent.module.scss';

interface ITableContentProps<T extends object> {
    data: T[];
    columns: TTableColumn<T>[];
    className?: string;
    rowKey?: (record: T) => string | number;
}

export const TableContent = <T extends object>({
    data,
    columns,
    className,
    rowKey,
}: ITableContentProps<T>) => {
    const [sortedData, setSortedData] = useState<T[]>(data);

    const handleTableChange = (
        _: number,
        __: TTableSort<T>,
        {
            sorter,
        }: {
            sorter: SorterResult<T> | SorterResult<T>[];
        },
    ) => {
        if (Array.isArray(sorter)) {
            return;
        }

        const { columnKey, order } = sorter;

        if (columnKey && order) {
            setSortedData(sortNumericValues(data, columnKey as keyof T, order));
        }
    };

    useEffect(() => {
        setSortedData(data);
    }, [data]);

    return (
        <div className={styles.container}>
            <Table
                className={cn(styles.table, className)}
                tableRows={sortedData}
                columns={columns}
                pagination={false}
                rowKey={rowKey}
                onChange={handleTableChange}
            />
        </div>
    );
};
